export const ATUALIZADO = 'Serviço atualizado'
export const CADASTRADO = 'Serviço adicionado'
export const NAO_ENCONTRADO = 'Não foram encontrados lançamentos cadastrados'
export const NAO_ENCONTRADO_FILTRO = 'Não há lançamentos com esse filtro'
export const ATENDIMENTO_CANCELADO_COM_SUCESSO = 'Atendimento cancelado com sucesso'
